import { Pencil, ArrowLeftRight, Trash2 } from "lucide-react";
import { hasPerm } from "../context/AuthContext";

// Boutons d'action sur un article (modifier/transférer/supprimer), communs
// à toutes les dispositions d'affichage du Stock — évite de dupliquer 5 fois
// la même logique de permissions.
export function StockArticleActions({ article, user, canEditAnyStockField, canTransfer, onEdit, onTransfer, onDelete, className = "" }) {
  if (!canEditAnyStockField) return null;
  return (
    <div className={className}>
      <button data-testid={`stock-edit-${article.id}`} onClick={(e) => { e.stopPropagation(); onEdit(article); }} className="p-1.5 rounded-md bg-background/90 border border-border" title="Modifier">
        <Pencil size={13} />
      </button>
      {canTransfer && (
        <button data-testid={`stock-transfer-${article.id}`} onClick={(e) => { e.stopPropagation(); onTransfer(article); }} title="Transférer vers une autre boutique" className="p-1.5 rounded-md bg-background/90 border border-border">
          <ArrowLeftRight size={13} />
        </button>
      )}
      {hasPerm(user, "stock", "delete") && (
        <button data-testid={`stock-delete-${article.id}`} onClick={(e) => { e.stopPropagation(); onDelete(article.id); }} className="p-1.5 rounded-md bg-background/90 border border-border text-destructive" title="Supprimer">
          <Trash2 size={13} />
        </button>
      )}
    </div>
  );
}
